import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white shadow-md py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => scrollTo("inicio")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/291e1e03275d7c1cc8fd6f7c97fde4c7/812ac9616e0f541892f666a14d15c875.png"
            alt="SUPERPISCINAS FLORIN Logo"
            className="h-20 w-auto object-contain"
          />
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Inicio", id: "inicio" },
            { label: "Nosotros", id: "nosotros" },
            { label: "Servicios", id: "servicios" },
            { label: "Galería", id: "galeria" },
            { label: "Contacto", id: "contacto" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-slate-700 hover:text-cyan-600" : "text-white hover:text-cyan-300"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Phone + CTA */}
        <div className="hidden md:flex items-center gap-4">
          <div className={`flex flex-col items-end text-xs ${scrolled ? "text-slate-600" : "text-white"}`}>
            <span className="flex items-center gap-1">
              <i className="ri-phone-line text-cyan-500"></i> 642 885 747
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-phone-line text-cyan-500"></i> 642 452 237
            </span>
          </div>
          <button
            onClick={() => scrollTo("contacto")}
            className="bg-cyan-500 hover:bg-cyan-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            Solicita Presupuesto
          </button>
        </div>

        {/* Hamburger */}
        <button
          className={`md:hidden text-2xl cursor-pointer ${scrolled ? "text-slate-700" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-4 flex flex-col gap-4">
          {[
            { label: "Inicio", id: "inicio" },
            { label: "Nosotros", id: "nosotros" },
            { label: "Servicios", id: "servicios" },
            { label: "Galería", id: "galeria" },
            { label: "Contacto", id: "contacto" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-slate-700 font-medium text-left hover:text-cyan-600 transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <div className="flex flex-col gap-1 text-sm text-slate-600 pt-2 border-t border-slate-100">
            <span><i className="ri-phone-line text-cyan-500 mr-1"></i> +34 600 000 001</span>
            <span><i className="ri-phone-line text-cyan-500 mr-1"></i> +34 600 000 002</span>
          </div>
          <button
            onClick={() => scrollTo("contacto")}
            className="bg-cyan-500 text-white font-semibold py-2.5 rounded-full text-sm cursor-pointer whitespace-nowrap"
          >
            Solicita Presupuesto
          </button>
        </div>
      )}
    </nav>
  );
}
